{
  "pageTitle": "Analitika",
  "pageDescription": "Pregled analitike vaših računa",
  "totalInvoices": "Ukupno računa",
  "totalPaid": "Ukupno plaćeno",
  "pending": "Na čekanju",
  "avgMonthly": "Prosječno mjesečno",
  "monthlySpending": "Mjesečni troškovi",
  "spendingByProvider": "Troškovi po pružatelju",
  "invoiceStatusDistribution": "Distribucija statusa računa",
  "spendingByAddress": "Troškovi po adresi"
}
